import { useAuthentication } from '@zenbusiness/application-commons-authentication';

/**
 * Email verification is tri-state: `true`, `false`, or `null` (unknown / not present).
 * Reads `useAuthentication().emailVerified`. OBO sessions always report unknown.
 *
 * @returns {boolean|null}
 */
export default function useEmailVerified() {
  const { obo, emailVerified } = useAuthentication() || {};

  if (obo) {
    return null;
  }

  return typeof emailVerified === 'boolean' ? emailVerified : null;
}
